import { Component, OnInit } from '@angular/core';
import { Personal } from '../../../models/personal';
import { generalService } from '../../../services/general.service';
import { MenuService } from '../menu/menu.service';

@Component({
  selector: 'my-app-sidenav-menu',
  styles: [],
  templateUrl: './sidenav-menu.component.html',
  providers: [ MenuService, generalService ]
})

export class AppSidenavMenuComponent implements OnInit {

  usuario: any;
  id_usuario: any;

  public menuItems:Array<any>;
  public menuItemsPerfil: Array<any> = [];
  public menuItemsParaMostrar:Array<any> = [];
  public menuCatalogo:Array<any> = [];
  public menuCatalogoParaMostrar:Array<any> = [];

  public menuCaja:Array<any> = [];
  public menuCajaParaMostrar:Array<any> = []
  public menuFacturacion:Array<any> = [];
  public menuFacturacionParaMostrar:Array<any> = []
  public menuInventarios:Array<any> = [];
  public menuInvetarioParaMostrar:Array<any> = []

  public menuContabilidad:Array<any> = [];
  public menuContabilidadParaMostrar:Array<any> = []

  public banderamenuCatalogo = true;
  public banderamenuCaja = true;
  public banderamenuFacturacion = true;
  public banderamenuInventario = true;
  public banderamenuContabilidad = true;

  constructor(private _generalService: generalService, 
    public menuService: MenuService) {

  }

  ngOnInit() {
    
    this.usuario = JSON.parse(sessionStorage.getItem("user"));
    this.id_usuario = this.usuario.USER_ID;

    this.menuItems = this.menuService.getMenuItems();
    this.menuCatalogo = this.menuService.getMenuCatalogo();
    this.menuCaja = this.menuService.getMenuCaja();
    this.menuFacturacion = this.menuService.getMenuFacturacion();
    this.menuInventarios = this.menuService.getMenuInventarios();
    this.menuContabilidad = this.menuService.getContabilidad();
    this.consultarMenu();
  }

  consultarMenu() {
    let personal = new Personal();
    personal.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(personal, "usuario/consultarMenu").subscribe(
      result => {
        this.menuItemsPerfil = JSON.parse(result);

        for(var i=0; i<this.menuItems.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuItems[i].codigo == menu.codigo) {
              this.menuItemsParaMostrar.push(this.menuItems[i]);
            }
          }
        }
        //Catalogo
        for(var i=0; i<this.menuCatalogo.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuCatalogo[i].codigo == menu.codigo) {
              this.menuCatalogoParaMostrar.push(this.menuCatalogo[i]);
            }
          }
        }
        //caja
        for(var i=0; i<this.menuCaja.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuCaja[i].codigo == menu.codigo) {
              this.menuCajaParaMostrar.push(this.menuCaja[i]);
            }
          }
        }
        //Facturacion
        for(var i=0; i<this.menuFacturacion.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuFacturacion[i].codigo == menu.codigo) {
              this.menuFacturacionParaMostrar.push(this.menuFacturacion[i]);
            }
          }
        }

         //Invetarios
         for(var i=0; i<this.menuInventarios.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuInventarios[i].codigo == menu.codigo) {
              this.menuInvetarioParaMostrar.push(this.menuInventarios[i]);
            }
          }
        }
        //Contavilidad
        for(var i=0; i<this.menuContabilidad.length; i++) {
          for(let menu of this.menuItemsPerfil) {
            if(this.menuContabilidad[i].codigo == menu.codigo) {
              this.menuContabilidadParaMostrar.push(this.menuContabilidad[i]);
            }
          }
        }

        

        this.validar();
       
      }, 
      error => {
        console.log(error);
      }
    )
  }
  validar(){
    
    if(this.menuCatalogoParaMostrar.length > 0){
      this.banderamenuCatalogo = false;
    }
    if(this.menuCajaParaMostrar.length > 0){
      this.banderamenuCaja = false;
    }
    if(this.menuFacturacionParaMostrar.length > 0){
      this.banderamenuFacturacion = false;
    }
    if(this.menuInvetarioParaMostrar.length > 0){
      this.banderamenuInventario = false;
    }
    if(this.menuContabilidadParaMostrar.length > 0){
      this.banderamenuContabilidad = false;
    }
    

  }

}


// WEBPACK FOOTER //
// ./src/app/layout/sidenav/sidenav-menu/sidenav-menu.component.ts